import React, { Component } from "react";
import ChangePasswordPage from "./newPassword.jsx"
import axios from 'axios';
import {
  baseURL
} from "../../../constants/applicationConstants.js";
import swal from 'sweetalert'
import { encrypt, passwordRegex } from '../../../shared/helper'
import { Loader } from "../loader/loader.jsx";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class ChangePass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        currentpassword: "",
        newpassword: "",
        verifypassword: "",
      },
      formError: {},
      formSubmitButtonDisable: true,
      isLoading: false,
      termAndCondition: false
    };
  }

  componentDidMount() {
    // Check if user should be redirected automatically
    this.checkForAutoRedirect();
  }

  checkForAutoRedirect = () => {
    try {
      const loginData = JSON.parse(localStorage.getItem('loginData'));
      
      if (loginData && loginData.isPermanentPasswordSet === true) {
        // Redirect based on loggedInAs value
        if (loginData.loggedInAs === "institute") {
          this.props.history.push("/dashboard");
        } else if (loginData.loggedInAs === "expert") {
          this.props.history.push("/expertDashboardHome");
        }
      }
    } catch (error) {
      console.error("Error checking auto-redirect:", error);
      // Continue with normal flow if there's an error parsing localStorage
    }
  }

  onTermsAndConditionClick = (value) => {
    // this.setState({ termAndCondition: value })
  }

  onInputChangeHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (value) {
      if (!this.inputRegexValidation(name, value)) {
        this.setState(
          {
            formData: {
              ...this.state.formData,
              [name]: value,
            },
            formError: {
              ...this.state.formError,
              [name]: "regx",
            },

          },
          () => this.isFromSubmissionBlock()
        );
      } else {
        this.setState(
          {
            formData: {
              ...this.state.formData,
              [name]: value,
            },
            formError: {
              ...this.state.formError,
              [name]: "",
            },
          },
          () => this.isFromSubmissionBlock()
        );
      }
    } else {
      this.setState(
        {
          formData: {
            ...this.state.formData,
            [name]: value,
          },
          formError: {
            ...this.state.formError,
            [name]: "",
          },
        },
        () => this.isFromSubmissionBlock()
      );
    }
  };

  onTouchHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (value === "") {
      this.setState({
        formError: {
          ...this.state.formError,
          [name]: "req",
        },
      });
    } else {
      if (!this.inputRegexValidation(name, value)) {
        this.setState({
          formError: {
            ...this.state.formError,
            [name]: "regx",
          },
        });
      }
    }
  };

  inputRegexValidation = (name, value) => {

    if (name === "currentpassword") {
      // return passwordRegex.test(value);
      return true;
    } else if (name === "newpassword") {
      return passwordRegex.test(value);
    } else if (name === "verifypassword") {
      return passwordRegex.test(value);
    }
  };

  isFromSubmissionBlock = () => {
    let { currentpassword, newpassword, verifypassword } = this.state.formData;
    if ((newpassword && verifypassword)) {
      if (
        !this.inputRegexValidation("currentpassword", currentpassword) ||
        !this.inputRegexValidation("newpassword", newpassword) ||
        !this.inputRegexValidation("verifypassword", verifypassword)

      ) {
        this.setState({
          formSubmitButtonDisable: true,
        });
      } else {
        if (newpassword === verifypassword) {
          this.setState({
            formSubmitButtonDisable: false,
            formError: {
              ...this.state.formError,
              verifypassword: "",
            }
          });
        } else {
          this.setState({
            formSubmitButtonDisable: true,
            formError: {
              ...this.state.formError,
              verifypassword: "notMatch",
            }
          });
        }
      }
    } else {
      this.setState({
        formSubmitButtonDisable: true,
      });
    }
  };

  formSubmitHandler = (e) => {
    e.preventDefault();
    const { currentpassword, newpassword, verifypassword } = this.state.formData;
    const token = JSON.parse(localStorage.getItem('token'));
    let flowType = localStorage.getItem("flowType")

    const id = JSON.parse(localStorage.getItem("masterID"));
    const expertId = JSON.parse(localStorage.getItem("expertId"));
    const loginData = JSON.parse(localStorage.getItem('loginData'));
    const instLoginType = localStorage.getItem('instLoginType') ?? '';
    const instUserId = localStorage.getItem('instUserId') ?? '';
    let data = {
      "password": encrypt(currentpassword),
      "newPassword": encrypt(newpassword),
      "confirmPassword": encrypt(verifypassword),
      "instituteId": id,
      "category": loginData?.loggedInAs === "institute_user" ? "institute_user" : "institute"
    }
    if (loginData?.loggedInAs === "institute_user"
    ) {
      delete data.instituteId;
      data.instituteUserId = loginData?.instituteUserId;
    }
    let dataExpert = {
      "password": encrypt(currentpassword),
      "newPassword": encrypt(newpassword),
      "confirmPassword": encrypt(verifypassword),
      "expertId": expertId,
      "category": "expert"
    }
    this.setState({
      isLoading: true
    })

    if(instLoginType === 'institute_user')
    {
      data.category = instLoginType;
      data.instituteId = instUserId;
      data.instituteUserId = instUserId;
    }

    let fetchUrl = `${baseURL}/changePassword`;

    axios.put(fetchUrl, flowType === "expert" ? dataExpert : data, {
      headers: {
        'x-access-token': token
      }
    }).then((resp) => {
      this.setState({
        isLoading: false
      })
      toast.success("Password updated.");
      swal({
        title: "success",
        text: "Password Updated successfully",
        icon: "success",
        successMode: true,
      }).then(res => {
        if (res) {
          flowType === "expert" ? this.props.history.push("/expertDashboardHome") : this.props.history.push("/dashboard");
        }
      });

    }).catch((res) => {
      this.setState({
        isLoading: false
      })
      toast.error(res?.response.data.error.message)

    })
  };

  handleChange = (e) => {
    const { checked } = e.target
    this.setState({
      termAndCondition: checked
    })
  }

  render() {
    return (
      <>
        <ChangePasswordPage
          formData={this.state.formData}
          onInputChangeHandler={this.onInputChangeHandler}
          onTouchHandler={this.onTouchHandler}
          formSubmitButtonDisable={this.state.formSubmitButtonDisable}
          formError={this.state.formError}
          formSubmitHandler={this.formSubmitHandler}
          handleChange={this.handleChange}
          onTermsAndConditionClick={this.onTermsAndConditionClick}
          termAndCondition={this.state.termAndCondition}
        />
        {this.state.isLoading && <Loader />}
      </>
    );
  }
}

export default ChangePass;